import React from 'react';
import emailjs from 'emailjs-com';
import { init } from 'emailjs-com';
import ParticlesBg from 'particles-bg';
import git_logo from '../../images/download (1).png';
import { Col, Container, Row } from 'reactstrap';
import { Form, FormGroup, Input, Button } from 'reactstrap';
import NavArea from '../Home/Header/NavArea';
import Footer from '../Footer/Footer';
import Headroom from 'react-headroom';
import { Helmet } from 'react-helmet';
const api = init('user_VHU9Wb29Fm86H3Y3ri9j9');

export default function Contacts() {
  document.title = 'Azim | | Contacts';

  function sendEmail(e) {
    e.preventDefault();
    emailjs.sendForm('services_azim', 'template_hyt559j', e.target, api).then(
      (result) => {
        if (result) {
          alert('message sent successfully to admin');
        }
      },
      (error) => {
        console.log(error.text);
      }
    );
    e.target.reset();
  }

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <meta
          name="Azim Uddin Ahamed"
          content="Azim Uddin Ahamed. Web Application Developer  . Textile Engineering Student. Proficient in pixel perfect UI with react ."
        />
      </Helmet>
      <section>
        <ParticlesBg className="bubbles" type="random" bg={true} />

        <Headroom
          style={{
            webkitTransition: 'all .5s ease-in-out',
            mozTransition: 'all .5s ease-in-out',
            oTransition: 'all .5s ease-in-out',
            transition: 'all .5s ease-in-out',
            background: '#0a192f',
            boxShadow: '1px 1px 1px rgba(0,0,0,0.25)',
          }}
        >
          <Container>
            {' '}
            <NavArea />{' '}
          </Container>
        </Headroom>
        <Container>
          <Row className="text-center py-4">
            <Col md={6} lg={6} sm={12}>
              <div
                className="p-5"
                style={{ background: '#101018f8', borderRadius: '10px' }}
              >
                <Form onSubmit={sendEmail}>
                  <FormGroup>
                    <Input
                      type="text"
                      name="name"
                      required
                      placeholder="Your Name"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Input
                      type="email"
                      name="email"
                      required
                      placeholder="Your Email Address"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Input
                      type="text"
                      required
                      name="message"
                      style={{ height: '8rem' }}
                      className="input-element"
                      placeholder="Your Message"
                    />
                  </FormGroup>
                  <Button size="lg" block outline type="submit" color="danger">
                    Send
                  </Button>
                  <p className="text-secondary mt-2">
                    sending to
                    <span className="text-white">
                      <strong>azimaahmed36@gmail.com</strong>
                    </span>
                  </p>
                </Form>
              </div>
            </Col>
            <Col md={6} lg={6} sm={12}>
              <ParticlesBg className="bubbles" type="random" bg={true} />

              <h3 className="text-danger">Also Connect with me</h3>
              <div>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://github.com/Azim-Ahmed"
                >
                  <img
                    className="my-3"
                    style={{
                      height: '70px',
                      width: '70px',
                      borderRadius: '7px',
                    }}
                    src={git_logo}
                    alt=""
                  />
                </a>
                <br />
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.linkedin.com/in/azimuahamed/"
                >
                  <img
                    className="my-3"
                    style={{
                      height: '70px',
                      width: '70px',
                      borderRadius: '7px',
                    }}
                    src="https://www.flaticon.com/svg/static/icons/svg/61/61109.svg"
                    alt=""
                  />
                </a>{' '}
                <br />
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.linkedin.com/in/azimuahamed/"
                >
                  <img
                    className="my-3"
                    style={{
                      height: '70px',
                      width: '70px',
                      borderRadius: '7px',
                    }}
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQO0wtU3V4sFNwY7QpQgZDu12GOytZnjrrKeg&usqp=CAU"
                    alt=""
                  />
                </a>
                <br />
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://azimuahamed.medium.com/"
                >
                  <img
                    className="my-3"
                    style={{
                      height: '70px',
                      width: '70px',
                      borderRadius: '7px',
                    }}
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/Medium_logo_Monogram.svg/1200px-Medium_logo_Monogram.svg.png"
                    alt=""
                  />
                </a>
              </div>
            </Col>
          </Row>
        </Container>
        <Footer />
      </section>
    </div>
  );
}
